/**
 * Program Summary Service
 * Register Angular Service for the Status Sumamry
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Directive
 */
import angular from 'angular';

angular.module('flsServices').directive('halfPieChart', function () {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            title: '@',
            data: '=',
            height: '@'
        },
        link: function (scope, element) {
            /* Assign the high chart*/
            Highcharts.chart(element[0], {
                chart: {
                    height:scope.height || 450,
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false
                },
                title: {
                    text: scope.title
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            distance: -50,
                            style: {
                                fontWeight: 'bold',
                                color: 'white'
                            },
                            format: '<b>{point.name}</b>',
                        },
                        startAngle: -90,
                        endAngle: 90,
                        center: ['50%', '85%'],
                        size: '150%'
                    }
                },
                series: [{
                    type: 'pie',
                    innerSize: '50%',
                    data: scope.data
                }]
            }, function(){
                this.setSize(this.plotSizeX, this.plotSizeY - 200)
            });
        }
    };
})
